import { Component, inject } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ICardAction } from "@tylertech/tyler-api-types";

export interface DetailDialogData<T = unknown>
{
    readonly cardActions: ICardAction[];
    readonly color: string;
    readonly detailUrl: string;
    readonly model: T;
}

@Component({
    selector: "detail-dialog-component",
    templateUrl: "./detailDialog.tmpl.html",
    standalone: false
})
export class DetailDialogComponent<T = unknown>
{
    private readonly dialogRef = inject<MatDialogRef<DetailDialogComponent, ICardAction | undefined>>(MatDialogRef);
    private readonly data = inject<DetailDialogData<T>>(MAT_DIALOG_DATA);


    get model(): T { return this.data.model; }
    get detailUrl(): string { return this.data.detailUrl; }
    get color(): string { return this.data.color; }
    get cardActions(): ICardAction[] { return this.data.cardActions; }

    getActionStyle(action: ICardAction): Record<string, string>
    {
        return {
            'fill': action.color
        };
    }

    close(action: ICardAction): void
    {
        this.dialogRef.close(action);
    }
}
